











import { Component, Vue, Prop } from "vue-property-decorator";

@Component({
  watch: {
    value() {
      (this as CModal).showModal();
    }
  }
})
export default class CModal extends Vue {
  @Prop({ type: String, required: true }) name!: string;
  @Prop({ type: Boolean, required: false, default: true }) value!: boolean;
  @Prop({ type: Boolean, required: false, default: true })
  clickToClose!: boolean;

  showModal() {
    this.value ? this.$modal.show(this.name) : this.$modal.hide(this.name);
  }

  mounted() {
    this.showModal();
  }
}
